import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './WelcomeModal.css';
import welcomeImageUrl from './images/welcome-image.png';

function WelcomeModal(props) {
  const { onClose } = props;

  return (
    <Modal show dialogClassName={styles.modal}>
      <Modal.Header>
        <Modal.Title>Welcome to Payment Configuration</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className={styles.imageRow}>
          <img src={welcomeImageUrl} />
        </div>

        <p className={styles.description}>
          Payment configuration allows you to customize the way your payment
          methods are displayed in your MokaPOS app.
        </p>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <button
          type="button"
          className="btn btn-primary btn-lg"
          onClick={onClose}
        >
          Learn more
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default WelcomeModal;
